// extracted by mini-css-extract-plugin
export default {"Education":"Education_Education__fpTIv","degreeType":"Education_degreeType__Y4gk3","honors":"Education_honors__04JbZ"};